import { render, staticRenderFns } from "./BankInstallmentCreate.vue?vue&type=template&id=93124052"
import script from "./BankInstallmentCreate.vue?vue&type=script&lang=js"
export * from "./BankInstallmentCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports